import type { UserId } from './ids.ts'

export enum TrackingEvent {
    USER_REGISTRATION_COMPLETED = 'user_registration_completed', // event track after user registration is completed

    TALENTBASE_REVEAL_PROFILE_REQUESTED = 'TALENTBASE_REVEAL_PROFILE_REQUESTED',
    TALENTBASE_REVEAL_PROFILE_REJECTED = 'TALENTBASE_REVEAL_PROFILE_REJECTED',
    TALENTBASE_REVEAL_PROFILE_ACCEPTED = 'TALENTBASE_REVEAL_PROFILE_ACCEPTED',

    CHAT_NEW_MESSAGE_NOTIFICATION = 'chat_new_message_notification',

    PROJECT_FIRST_RESPONSE_VOLUNTEER = 'projekt_prva_odpoved_dobrovolnika',
    PROJECT_FIRST_RESPONSE_ORG = 'projekt_prva_odpoved_organizacie',
    MENTOR_FIRST_RESPONSE = 'mentoring_prva_odpoved_mentora',
    MENTORING_FINISHED_BY_MENTEE = 'mentoring_ukonceny_menteem',
    MENTORING_FINISHED_BY_MENTOR = 'mentoring_ukonceny_mentorom',
    MENTORING_ACCEPTED = 'mentoring_prijaty',
    MENTORING_COOPERATION_FEEDBACK_MENTOR = 'mentoring_prijaty_feedback_mentor',
    MENTORING_COOPERATION_FEEDBACK_MENTEE = 'mentoring_prijaty_feedback_mentee',
    MENTORING_RESOLUTION_POSTPONED_MENTOR = 'mentoring_odlozenie_rozhodnutia_mentor',

    MENTORING_FEEDBACK_POSTPONED_MENTOR = 'mentoring_odlozenie_feedbacku_mentor',
    MENTORING_FEEDBACK_POSTPONED_MENTEE = 'mentoring_odlozenie_feedbacku_mentee',
    MENTORING_FEEDBACK_MENTOR = 'mentoring_feedback_mentor',
    MENTORING_FEEDBACK_MENTEE = 'mentoring_feedback_mentee',

    COOPERATION_FEEDBACK_POSTPONED_ORG = 'mentoring_odlozenie_feedbacku_org',
    COOPERATION_FEEDBACK_POSTPONED_PARTICIPANT = 'mentoring_odlozenie_feedbacku_participant',
    COOPERATION_FEEDBACK_ORG = 'mentoring_feedback_org',
    COOPERATION_FEEDBACK_PARTICIPANT = 'mentoring_feedback_participant',

    ORG_CREATED = 'vytvorena_organizacia',
    ORG_UPDATED = 'upravena_organizacia',
    ORG_CREDITS_ORDERED = 'org_objednane_kredity',
    ORG_CREDITS_ASSIGNED = 'org_pridelenie_kreditov',
    ORG_NO_CREDITS = 'org_organizacia_nema_kredity',

    COMMUNITY_FEED_POST_CREATED = 'vytvoreny_post_v_komunite',

    MENTORING_REJECTED = 'mentoring_zamietnuty',
    MENTORING_REQUESTED = 'zaujem_o_mentoring',
    MENTORING_OFFERED = 'mentoring_ponuka_od_mentora',
    VOLUNTEER_REQUESTED = 'zaujem_o_dobrovolnika',
    PROJECT_CREATED = 'vytvorit_projekt_dobrovolnictva',
    PROJECT_POSTED_YESTERDAY = 'project_posted_yesterday',
    PROJECT_REQUESTED = 'zaujem_o_projekt',
    PROJECT_REQUESTED_ORG = 'zaujem_o_projekt_org',
    PROJECT_UNPUBLISH_AFTER_START = 'project_hidden_after_start',
    PROJECT_UNPUBLISH_AFTER_3_MONTHS = 'project_hidden_after_3_months',
    PROJECT_COOPERATION_STARTED_BY_VOLUNTEER = 'dobrovolnictvo_spustene_dobrovolnikom',
    PROJECT_COOPERATION_STARTED_BY_ORG = 'dobrovolnictvo_spustene_organizaciou',
    PROJECT_COOPERATION_FEEDBACK_ORG = 'dobrovolnictvo_spolupraca_feedback_org',
    PROJECT_COOPERATION_FEEDBACK_VOLUNTEER = 'dobrovolnictvo_spolupraca_feedback_dobrovolnik',
    PROJECT_RESOLUTION_POSTPONED_ORG = 'dobrovolnictvo_odlozenie_rozhodnutia_org',
    PROJECT_RESOLUTION_POSTPONED_VOLUNTEER = 'dobrovolnictvo_odlozenie_rozhodnutia_dobrovolnik',
    MISLEADING_USER_ACTION = 'misleading_user_action',

    JOB_CREATED = 'vytvoreny_job',
    JOB_UPDATED = 'upraveny_job',
    JOB_REQUESTED = 'zaujem_o_job',
    JOB_EXTEND_APPLICATIONS = 'job_predlzenie_vyberoveho_procesu',
    JOB_AUTO_UNPUBLISH = 'job_auto_unpublish',
    JOB_7_DAYS_AFTER_CREATED_AT = 'job_7_days_after_created_at',
    JOB_7_DAYS_BEFORE_END_DATE = 'job_7_days_before_end_date',
    JOB_DONT_FORGET_REMINDER = 'job_dont_forget_reminder',
    JOB_POSTED_YESTERDAY = 'job_posted_yesterday',

    // JOB_CREATED_END_DATE = 'vytvoreny_job_datum_ukoncenia', // has set end date - event track was moved to Exponea scenario for 'vytvoreny_job'
    // JOB_CREATED_ASAP = 'vytvoreny_job_nastup_ihned', // end date is ASAP - event track was moved to Exponea scenario for 'vytvoreny_job'
    PROJECT_COOPERATION_FINISHED_BY_ORG = 'dobrovolnictvo_ukoncene_organizaciou',
    PROJECT_COOPERATION_FINISHED_BY_VOLUNTEER = 'dobrovolnictvo_ukoncene_dobrovolnikom',
    PROJECT_COOPERATION_REJECTED_BY_ORG = 'dobrovolnictvo_zamietnute_organizaciou',
    PROJECT_PUBLISHED_NEW = 'projekt_prvykrat_publikovany',
    PROJECT_VISIBILITY_CHANGE = 'uprava_viditelnosti_projektu',
    FEEDBACK_GIVEN = 'feedback_odoslany',
    // In-product NPS answers. Kept separate from FEEDBACK_GIVEN so they can be merged
    // with the NPS the Bloomreach mails collect.
    NPS_GIVEN = 'nps_given',
    B2B_CONTACT_FORM_REQUEST_SENT = 'b2b_contact_form_sent',

    // Volunteering week events
    VOLUNTEERING_WEEK_PROJECT_CREATED = 'volunteering_week_project_created',
    VOLUNTEERING_WEEK_PROJECT_REMINDER_ORG = 'volunteering_week_project_reminder_org',
    // Bloomreach has this legacy event type configured with the Slovak "projekt" spelling.
    VOLUNTEERING_WEEK_PROJECT_REMINDER_VOLUNTEER = 'volunteering_week_projekt_reminder_volunteer',
    VOLUNTEERING_WEEK_PROJECT_REQUESTED = 'zaujem_o_dobroweek_projekt',
    VOLUNTEERING_WEEK_PROJECT_REQUESTED_ORG = 'zaujem_o_dobroweek_projekt_org_notif',

    // Project tips
    PROJECT_10_DAYS_TIPS = 'project_10_days_tips'
}

export type CustomerIdsType = {
    registered?: UserId // HARD_ID: Customer ID from Firebase database
    registered_email?: string // HARD_ID: Customer registration email from Firebase Authentication
    cookie?: string // SOFT_ID: Used for merge unregistered customers, Exponea cookie from browser, value "__exponea_etc__"
}

// Allowed properties which can be updated via Exponea API
// List of properties: https://app.exponea.com/p/growni-test/project-settings/api?action=properties
export type CustomerPropertiesType = {
    email?: string // Contact email, can be different from the registration email "registered_email"
    firstName?: string
    lastName?: string
    phone?: string
}

// Get current consent information for a specified customer
// https://documentation.bloomreach.com/engagement/reference/customer-consents-2
export type CustomerAttributesType = {
    type: string
    category: string
    mode: string
}[]

// Our custom type for update customer properties in function updateExponeaUser() and Exponea API
export type UpdateExponeaUserType = {
    customerIds: CustomerIdsType
    customerProperties: CustomerPropertiesType
}

// Our custom Exponea type for tracking function trackExponeaEvent() and Exponea API
export type TrackExponeaEventType = {
    eventName: string
    userId?: string // use Firebase User ID or Firebase user authentication
    eventProperties: object
    cookie?: string
}
